import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		searchBar: {
			backgroundColor: "white",
			borderRadius: 4,
			padding: "5px 20px",
		},
		filter: {
			textAlign: "right"
		},
		filterMobileButton: {
			paddingLeft: 2,
			paddingRight: 2,
		},
		filterIcon: {
			marginTop: "2px",
			marginBottom: "2px",
		},
		leadsTableContainer: {
			width: "100%", 
			overflow: "hidden" 
		}
	} satisfies Record<string, CSSObject>;
};
